import React, { Component } from 'react';

import classes from './SimilarArticles.module.scss';
import articlesJSON from 'data/articles.json'
import globalJSON from 'data/global.json'
import { Link  } from "react-router-dom";
import renderHTML from 'react-render-html';

import { getFileName } from 'helpers/FileCaching';
const thumbnails = require.context('images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);

class SimilarArticles extends Component {

    constructor(props){

        super(props);

        this.articleMarkup = []

        this.state = {
            articleMarkup:[]
        }

        this.getArticleMarkup(this.props);

    }

    componentWillReceiveProps(nextProps){

        this.getArticleMarkup(nextProps);

    }

    onClick(event){
		window.gtag('event', "similar article selection", {
			'event_category': globalJSON.tracking.ga_category,
			'event_label': "similar article clicked "+ event.currentTarget.href,
			'value':10
          });
        window.scrollTo(0,0);
	}

    getArticleMarkup(articlelist){
        
        this.state.articleMarkup = [];

        for (var item in articlelist.content.ids) {

            let idRef = articlelist.content.ids[item];
            let articleContent = articlesJSON.articles.find( article => article.id == idRef );

            this.state.articleMarkup.push(

                <div key={item} className={classes.similarArticles__article}>
                    <Link onClick={this.onClick} to={process.env.PUBLIC_URL+'/'+articleContent.url} className={`radial-link ${classes['similarArticles__article--link']}`}>
                
                        <div className={classes['similarArticles__article--imageContainer']}>
                            <div className={`radial-images-container ${classes['similarArticles__article--container-image']}`}>
                                <div className={`radial-images ${classes['similarArticles__article--image']}`} style={

                                        {
                                            backgroundImage: 'url(' + getFileName(thumbnails, articleContent.thumbnail) + ')'
                                        }
                            
                                    }
                                >

                                </div>
                            </div>
                        </div>

                        <div className={classes['similarArticles_articles__article--titleContainer']}>
                            <header className={classes['similarArticles__article--title']}>{renderHTML(articleContent.hero.caption)}</header>
                        </div>
                    </Link>

                </div>
            )

         }
     
    }

    similarArticleMarkup(){


    }


    render(){
        return (
      
            <section className={classes.similarArticles}>
                <div className={`text_subtitle_wrapper`}>
                    <p  className={`${classes.similarArticles__Subtitle}` }>{articlesJSON.text.similar}</p>
                </div>
                <div className={classes.similarArticles__wrapper}>
                    {this.state.articleMarkup}
                </div>
            </section>
         
        );
    }
}

export default SimilarArticles;

